export function getCookie(name: string): string | undefined {
  if (typeof document === 'undefined' || typeof window === 'undefined') {
    console.warn('Document is not available in this environment.');
    return undefined;
  }
  const match = document?.cookie?.match(new RegExp('(^|; )' + name + '=([^;]*)'));
  return match ? decodeURIComponent(match[2]) : undefined;
}

export const getGaAnonymousId = () => {
  try {
    if (typeof window === 'undefined') {
      console.warn('LocalStorage is not available in this environment.');
      return null;
    }
    const gaID = window?.localStorage?.getItem('ajs_anonymous_id');
    const gaAnonymousId = gaID ? JSON.parse(gaID) : null;
    return gaAnonymousId;
  } catch (error) {
    console.error('Error retrieving GA anonymous ID:', error);
    return null;
  }
};
export function getDeviceType(): 'Desktop' | 'Mobile' | 'Tablet' | 'Unknown' {
  if (typeof window === 'undefined') return 'Unknown';

  const ua = window?.navigator?.userAgent;

  if (/mobile/i.test(ua)) {
    return 'Mobile';
  }
  if (/tablet|ipad|playbook|silk/i.test(ua)) {
    return 'Tablet';
  }
  if (/android/i.test(ua) && !/mobile/i.test(ua)) {
    return 'Tablet';
  }
  if (/desktop|windows|macintosh|linux/i.test(ua)) {
    return 'Desktop';
  }
  // Fallback
  if (window?.innerWidth <= 800) {
    return 'Mobile';
  }
  return 'Unknown';
}

export function getBrowserName(): string {
  if (typeof window === 'undefined') return 'Unknown';

  const ua = window?.navigator?.userAgent;

  if (/chrome|crios|crmo/i.test(ua) && !/edge|edg|opr|opera/i.test(ua)) {
    return 'Chrome';
  }
  if (/firefox|fxios/i.test(ua)) {
    return 'Firefox';
  }
  if (/safari/i.test(ua) && !/chrome|crios|crmo|android/i.test(ua)) {
    return 'Safari';
  }
  if (/edg|edge/i.test(ua)) {
    return 'Edge';
  }
  if (/opr|opera/i.test(ua)) {
    return 'Opera';
  }
  if (/msie|trident/i.test(ua)) {
    return 'Internet Explorer';
  }
  return 'Unknown';
}

export function getOperatingSystem(): string {
  if (typeof window === 'undefined') return 'unknown';

  const userAgent = window?.navigator?.userAgent;

  if (/windows/i.test(userAgent)) {
    return 'Windows';
  }
  if (/macintosh|mac os x/i.test(userAgent)) {
    return 'MacIntel';
  }
  if (/linux/i.test(userAgent)) {
    return 'Linux';
  }
  if (/ubuntu/i.test(userAgent)) {
    return 'Ubuntu';
  }
  if (/android/i.test(userAgent)) {
    return 'Android';
  }
  if (/iphone|ipad|ipod/i.test(userAgent)) {
    return 'iOS';
  }

  return 'unknown';
}

export const getPageInfo = (): { pageName: string; pageSection: string; pageStage: string } => {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    console.warn('Document is not available in this environment.');
    return { pageName: '', pageSection: '', pageStage: '' };
  }

  const metaTags = Array.from(document.querySelectorAll('meta'));

  let pageName = '';
  let pageSection = '';
  let pageStage = '';

  for (const tag of metaTags) {
    const name = tag.getAttribute('name');
    if (!name) continue;

    switch (name) {
      case 'pageName':
        pageName = tag.content || '';
        break;
      case 'pageSection':
        pageSection = tag.content || '';
        break;
      case 'pageStage':
        pageStage = tag.content || '';
        break;
    }

    // Break early if all values are found
    if (pageName && pageSection && pageStage) break;
  }

  return { pageName, pageSection, pageStage };
};
